<script>
import Layout from "@/router/layouts/main";
import StepperNav from "@/components/energia/StepperNav.vue";
import { api } from "@/state/services";

const ETAPAS = [
  { numero: 1, label: 'Tipo' },
  { numero: 2, label: 'Dados' },
  { numero: 3, label: 'Endereço' },
]

export default {
  components: { Layout, StepperNav },

  data() {
    return {
      etapaAtual: 1,
      etapasConcluidas: [],
      saving: false,
      erroSalvar: '',
      etapas: ETAPAS,

      form: {
        // Etapa 1 — tipo
        type: '',

        // Etapa 2 — dados do cliente
        client_name: '',
        client_email: '',
        client_phone: '',

        // Etapa 2 — dados da usina (fotovoltaica e hídrica)
        gd_type: '',
        installed_power: '',
        situation: '',
        expected_date: '',
        connection_class: '',
        monthly_kwh: '',
        has_credits: '',

        // Comuns (etapa 2)
        distributor: '',
        region: '',

        // Etapa 3 — endereço
        zipcode: '',
        address: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
      },

      erroCep: '',
      buscandoCep: false,
    }
  },

  computed: {
    isFotovoltaica() {
      return this.form.type === 'fotovoltaica'
    },

    isHidrica() {
      return this.form.type === 'hidrica'
    },
  },

  methods: {
    irPara(etapa) {
      if (this.etapasConcluidas.includes(etapa) || etapa === this.etapaAtual) {
        this.etapaAtual = etapa
      }
    },

    avancarEtapa1() {
      if (!this.form.type) {
        return
      }
      this.etapasConcluidas = [...new Set([...this.etapasConcluidas, 1])]
      this.etapaAtual = 2
    },

    avancarEtapa2() {
      if (!this.form.client_name.trim() || !this.form.client_email.trim()) {
        return
      }

      if (!this.form.gd_type || !this.form.installed_power ||
          !this.form.situation || !this.form.connection_class ||
          !this.form.monthly_kwh || !this.form.has_credits || !this.form.distributor) {
        return
      }
      this.etapasConcluidas = [...new Set([...this.etapasConcluidas, 2])]
      this.etapaAtual = 3
    },

    async buscarCep() {
      const cep = this.form.zipcode.replace(/\D/g, '')
      if (cep.length !== 8) return
      this.buscandoCep = true
      this.erroCep = ''
      try {
        const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
        const data = await res.json()
        if (data.erro) {
          this.erroCep = 'CEP não encontrado.'
          return
        }
        this.form.address  = data.logradouro || ''
        this.form.district = data.bairro     || ''
        this.form.city     = data.localidade || ''
        this.form.state    = data.uf         || ''
      } catch {
        this.erroCep = 'Erro ao buscar o CEP.'
      } finally {
        this.buscandoCep = false
      }
    },

    async salvar() {
      if (!this.form.zipcode || !this.form.address || !this.form.number ||
          !this.form.city || !this.form.state) {
        return
      }

      this.saving = true
      this.erroSalvar = ''

      const payload = {
        type:         this.form.type,
        client_name:  this.form.client_name,
        client_email: this.form.client_email,
        client_phone: this.form.client_phone,
        distributor:  this.form.distributor,
        region:      this.form.region,
        zipcode:     this.form.zipcode,
        address:     this.form.address,
        number:      this.form.number,
        complement:  this.form.complement,
        district:    this.form.district,
        city:        this.form.city,
        state:       this.form.state,
      }

      Object.assign(payload, {
        gd_type:          this.form.gd_type,
        installed_power:  this.form.installed_power,
        situation:        this.form.situation,
        expected_date:    this.form.expected_date,
        connection_class: this.form.connection_class,
        monthly_kwh:      this.form.monthly_kwh,
        has_credits:      this.form.has_credits,
      })

      try {
        const response = await api.post('usinas/create', payload)
        if (response.data.status === 'success') {
          const idUsina = response.data.usina.id
          this.$router.push('/usinas/' + idUsina)
        } else {
          this.erroSalvar = response.data.message || 'Erro ao cadastrar a usina.'
        }
      } catch {
        this.erroSalvar = 'Erro ao conectar com o servidor.'
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link to="/usinas">Usinas</router-link>
      </li>
      <li class="breadcrumb-item active">Nova usina</li>
    </ol>

    <div class="page-title-box">
      <h3>Nova usina</h3>
    </div>

    <div class="card">
      <div class="card-body">
        <StepperNav
          :etapas="etapas"
          :atual="etapaAtual"
          :concluidas="etapasConcluidas"
          @ir-para="irPara"
        />

        <!-- Etapa 1: Tipo -->
        <div v-if="etapaAtual === 1">
          <h5 class="mb-4">Qual o tipo da usina?</h5>
          <div class="row justify-content-center mb-2">
            <div class="col-md-5 mb-3">
              <div
                class="card border cursor-pointer"
                :class="{ 'border-primary': form.type === 'fotovoltaica' }"
                style="cursor: pointer;"
                @click="form.type = 'fotovoltaica'"
              >
                <div class="card-body text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"></path></svg>
                  <h5 class="mb-1">Fotovoltaica</h5>
                  <p class="text-muted mb-0 small">Energia solar</p>
                </div>
              </div>
            </div>
            <div class="col-md-5 mb-3">
              <div
                class="card border cursor-pointer"
                :class="{ 'border-primary': form.type === 'hidrica' }"
                style="cursor: pointer;"
                @click="form.type = 'hidrica'"
              >
                <div class="card-body text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M5.996 9c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707C11.83 8.253 12.577 9 13.991 9c1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 8.253 20.585 9 22 9V7c-.563 0-.804-.217-1.295-.707C20.159 5.747 19.411 5 17.996 5s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 5.747 11.407 5 9.993 5s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 5.747 3.413 5 2 5v2c.561 0 .801.217 1.291.707C3.836 8.253 4.583 9 5.996 9zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 13.253 20.585 14 22 14v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 10.747 11.407 10 9.993 10s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 10.747 3.413 10 2 10v2c.561 0 .801.217 1.291.707C3.836 13.253 4.583 14 5.996 14zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 18.253 20.585 19 22 19v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 15.747 11.407 15 9.993 15s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 15.747 3.413 15 2 15v2c.561 0 .801.217 1.291.707C3.836 18.253 4.583 19 5.996 19z"></path></svg>
                  <h5 class="mb-1">Hídrica</h5>
                  <p class="text-muted mb-0 small">Energia hidrelétrica</p>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <button
              class="btn btn-primary btn-lg"
              :disabled="!form.type"
              @click="avancarEtapa1"
            >
              Continuar <i class="bx bx-chevron-right ml-1"></i>
            </button>
          </div>
        </div>

        <!-- Etapa 2: Dados -->
        <div v-if="etapaAtual === 2">
          <h5 class="mb-4">Dados da usina</h5>

          <!-- Dados do cliente -->
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Nome do cliente <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.client_name" type="text" class="form-control" placeholder="Nome completo">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">E-mail do cliente <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.client_email" type="email" class="form-control" placeholder="email@exemplo.com">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Celular do cliente</label>
            <div class="col-sm-4">
              <input v-model="form.client_phone" type="text" class="form-control" placeholder="(00) 00000-0000">
            </div>
          </div>

          <!-- Campos iguais para fotovoltaica e hídrica -->
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">GD <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select v-model="form.gd_type" class="form-control">
                <option value="">Selecione</option>
                <option value="gd1">GD 1</option>
                <option value="gd2">GD 2</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Potência instalada <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.installed_power" type="text" class="form-control" placeholder="Ex: 450 kWp">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Situação da usina <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select v-model="form.situation" class="form-control">
                <option value="">Selecione</option>
                <option value="homologada">Homologada e operando</option>
                <option value="homologacao">Em homologação</option>
                <option value="construcao">Em construção</option>
              </select>
            </div>
          </div>

          <div v-if="form.situation === 'construcao'" class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Data prevista para início de geração</label>
            <div class="col-sm-6">
              <input v-model="form.expected_date" type="date" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Classe da conexão <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select v-model="form.connection_class" class="form-control">
                <option value="">Selecione</option>
                <option value="grupo_a">Grupo A — Mercado Livre</option>
                <option value="grupo_b">Grupo B — Geração Distribuída</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Média mensal (kWh/mês) <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.monthly_kwh" type="text" class="form-control" placeholder="Ex: 15000">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Possui créditos sobrando? <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select v-model="form.has_credits" class="form-control">
                <option value="">Selecione</option>
                <option value="yes">Sim</option>
                <option value="no">Não</option>
                <option value="sometimes">Às vezes</option>
              </select>
            </div>
          </div>

          <!-- Comuns -->
          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Distribuidora / Concessionária <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.distributor" type="text" class="form-control" placeholder="Ex: Celesc, RGE, CPFL">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Localização da Usina</label>
            <div class="col-sm-6">
              <input v-model="form.region" type="text" class="form-control">
            </div>
          </div>

          <div class="d-flex justify-content-between mt-4">
            <button class="btn btn-default" @click="etapaAtual = 1">
              <i class="bx bx-chevron-left mr-1"></i> Voltar
            </button>
            <button class="btn btn-primary" @click="avancarEtapa2">
              Continuar <i class="bx bx-chevron-right ml-1"></i>
            </button>
          </div>
        </div>

        <!-- Etapa 3: Endereço -->
        <div v-if="etapaAtual === 3">
          <h5 class="mb-4">Endereço da usina</h5>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">CEP <span class="text-danger">*</span></label>
            <div class="col-sm-4">
              <div class="input-group">
                <input
                  v-model="form.zipcode"
                  type="text"
                  class="form-control"
                  placeholder="00000-000"
                  maxlength="9"
                  @blur="buscarCep"
                >
                <div class="input-group-append">
                  <button class="btn btn-default" type="button" :disabled="buscandoCep" @click="buscarCep">
                    <i v-if="buscandoCep" class="bx bx-loader-alt bx-spin"></i>
                    <i v-else class="bx bx-search"></i>
                  </button>
                </div>
              </div>
              <small v-if="erroCep" class="text-danger">{{ erroCep }}</small>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Logradouro <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.address" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Número <span class="text-danger">*</span></label>
            <div class="col-sm-3">
              <input v-model="form.number" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Complemento</label>
            <div class="col-sm-6">
              <input v-model="form.complement" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Bairro</label>
            <div class="col-sm-6">
              <input v-model="form.district" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">Cidade <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <input v-model="form.city" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-4 col-form-label text-sm-right">UF <span class="text-danger">*</span></label>
            <div class="col-sm-2">
              <input v-model="form.state" type="text" class="form-control" maxlength="2">
            </div>
          </div>

          <div v-if="erroSalvar" class="alert alert-danger mt-3">{{ erroSalvar }}</div>

          <div class="d-flex justify-content-between mt-4">
            <button class="btn btn-default" @click="etapaAtual = 2">
              <i class="bx bx-chevron-left mr-1"></i> Voltar
            </button>
            <button
              class="btn btn-success"
              :disabled="saving || !form.zipcode || !form.address || !form.number || !form.city || !form.state"
              @click="salvar"
            >
              <i v-if="saving" class="bx bx-loader-alt bx-spin mr-1"></i>
              <i v-else class="bx bx-check mr-1"></i>
              Cadastrar usina
            </button>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>
